/**
 * 잘못된 패스워드
 */
 export default class WrongPasswordError extends Error {}